import { IValues } from "./types";

export const DEFAULT_SIGNUP_REQUIRED: IValues["required"] = {
  username: true,
  password: true,
  email: true,
  familyName: false,
  name: false,
  surname: false,
  company: false,
  phone: false,
  goals: false,
};

export const DEFAULT_INVITE_REQUIRED: IValues["required"] = {
  username: true,
  password: false,
  email: true,
  familyName: false,
  name: false,
  surname: false,
  company: false,
  phone: false,
  goals: true,
};
